"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
var _default = exports.default = {
  methods: {
    /** 设置 表格操作按钮
      * @description: 设置 表头
      * @return { void }
      */
    setTableRowOperations: function setTableRowOperations() {
      var _this$operations,
        _this = this;
      this.tableOperations = (_this$operations = this.operations) === null || _this$operations === void 0 || (_this$operations = _this$operations.map(this.$$handleButton)) === null || _this$operations === void 0 ? void 0 : _this$operations.map(function (btn) {
        var _btn$code, _btn$size, _btn$name, _btn$name2, _btn$name3, _btn$name4, _btn$name5, _btn$name6, _btn$label, _btn$tooltip;
        if (!btn.btnType) {
          btn.btnType = btn.type;
          btn.type = 'primary';
        }
        (_btn$code = btn.code) !== null && _btn$code !== void 0 ? _btn$code : btn.code = btn.btnType;
        (_btn$size = btn.size) !== null && _btn$size !== void 0 ? _btn$size : btn.size = 'mini';
        btn.btnType = _this.$$alterNomenclature(btn.btnType, '-');
        var label = '';
        switch (_this.$$alterNomenclature(btn.code, '-')) {
          case 'add':
            label = (_btn$name = btn.name) !== null && _btn$name !== void 0 ? _btn$name : '新增';
            btn.icon = 'el-icon-plus';
            break;
          case 'delete':
            label = (_btn$name2 = btn.name) !== null && _btn$name2 !== void 0 ? _btn$name2 : '删除';
            btn.icon = 'el-icon-delete';
            break;
          case 'export':
            label = (_btn$name3 = btn.name) !== null && _btn$name3 !== void 0 ? _btn$name3 : '导出';
            btn.name = '导出';
            btn.icon = 'el-icon-download';
            break;
          case 'import':
            label = (_btn$name4 = btn.name) !== null && _btn$name4 !== void 0 ? _btn$name4 : '导入';
            btn.name = '导入';
            btn.title = '导入';
            btn.icon = 'el-icon-upload2';
            break;
          case 'import-record':
            label = (_btn$name5 = btn.name) !== null && _btn$name5 !== void 0 ? _btn$name5 : '导入记录';
            btn.name = '导入记录';
            btn.title = '导入记录';
            btn.icon = 'el-icon-upload';
            break;
          case 'jm-print':
            label = (_btn$name6 = btn.name) !== null && _btn$name6 !== void 0 ? _btn$name6 : '打印';
            btn.name = '打印';
            btn.icon = 'el-icon-download';
            break;
          default:
            break;
        }
        (_btn$label = btn.label) !== null && _btn$label !== void 0 ? _btn$label : btn.label = label;
        (_btn$tooltip = btn.tooltip) !== null && _btn$tooltip !== void 0 ? _btn$tooltip : btn.tooltip = {
          content: btn.label
        };
        return btn;
      });
    },
    /**
     * @description: 表格操作按钮点击事件
     * @param { Object } btn 按钮对象
     * @param { Object } e 点击事件对象
     * @return { void }
     */
    operationClick: function operationClick(btn, e) {
      /* 如果是导出按钮 */
      if (btn.btnType === 'export') {
        this.exportExcel(btn);
      }
      if (typeof btn.click === 'function') btn.click(btn, e);else if (typeof btn.onclick === 'function') btn.onclick(btn, e);else if (typeof btn.onClick === 'function') btn.onClick(btn, e);
    }
  }
};